import { Navigate, Route, Routes } from "react-router-dom";

import ProtectedRoute from "./ProtectedRoute";
import { PublicRoutesConfig, AdminRoutesConfig, CommonRoutesConfig } from "./RoutesConfig";
import Logout from "./pages/Logout";
import Login from "./pages/Login";
import LoginWithPassword from "./pages/LoginWithPassword";
import Profile from "./pages/Profile";
import Home from "./pages/Home";

import AdminLogin from "./admin/pages/Login";
import AdminHome from "./admin/pages/Home";

import InputNotary from "./admin/pages/users/notaries/Input";
import SearchNotaries from "./admin/pages/users/notaries/Search";
import PreviewNotary from "./admin/pages/users/notaries/Preview";

import InputNotaryDeputy from "./admin/pages/users/notaryDeputies/Input";
import SearchNotaryDeputies from "./admin/pages/users/notaryDeputies/Search";
import PreviewNotaryDeputy from "./admin/pages/users/notaryDeputies/Preview";

import InputExternalUser from "./admin/pages/users/externalUsers/Input";
import SearchExternalUsers from "./admin/pages/users/externalUsers/Search";
import PreviewExternalUser from "./admin/pages/users/externalUsers/Preview";

import InputRegistryAgencyUser from "./admin/pages/users/registryAgencyUsers/Input";
import SearchRegistryAgencyUsers from "./admin/pages/users/registryAgencyUsers/Search";
import PreviewRegistryAgencyUser from "./admin/pages/users/registryAgencyUsers/Preview";

import InputBankUser from "./admin/pages/users/bankUsers/Input";
import SearchBankUsers from "./admin/pages/users/bankUsers/Search";
import PreviewBankUser from "./admin/pages/users/bankUsers/Preview";

import InputInvestmentBrokerUser from "./admin/pages/users/investmentBrokerUsers/Input";
import SearchInvestmentBrokerUsers from "./admin/pages/users/investmentBrokerUsers/Search";
import PreviewInvestmentBrokerUser from "./admin/pages/users/investmentBrokerUsers/Preview";

import InputInsurerUser from "./admin/pages/users/insurerUsers/Input";
import SearchInsurerUsers from "./admin/pages/users/insurerUsers/Search";
import PreviewInsurerUser from "./admin/pages/users/insurerUsers/Preview";

import InputMayor from "./admin/pages/users/mayors/Input";
import SearchMayors from "./admin/pages/users/mayors/Search";
import PreviewMayor from "./admin/pages/users/mayors/Preview";

import InputBank from "./admin/pages/nomenclatures/banks/Input";
import SearchBanks from "./admin/pages/nomenclatures/banks/Search";

import InputBankBranch from "./admin/pages/nomenclatures/bankBranches/Input";
import SearchBankBranches from "./admin/pages/nomenclatures/bankBranches/Search";

import InputInvestmentBroker from "./admin/pages/nomenclatures/investmentBrokers/Input";
import SearchInvestmentBrokers from "./admin/pages/nomenclatures/investmentBrokers/Search";

import InputInvestmentBrokerBranch from "./admin/pages/nomenclatures/investmentBrokerBranches/Input";
import SearchInvestmentBrokerBranches from "./admin/pages/nomenclatures/investmentBrokerBranches/Search";

import InputInsurer from "./admin/pages/nomenclatures/insurers/Input";
import SearchInsurers from "./admin/pages/nomenclatures/insurers/Search";

import InputInsurerBranch from "./admin/pages/nomenclatures/insurerBranches/Input";
import SearchInsurerBranches from "./admin/pages/nomenclatures/insurerBranches/Search";

import SearchReports from "./admin/pages/periodicReports/Search";

import InputAuthorization from "./pages/authorizations/Input";
import PreviewAuthorization from "./pages/authorizations/Preview";
import HistoryPreviewAuthorization from "./pages/authorizations/HistoryPreview";
import SearchAuthorizations from "./pages/authorizations/Search";

import Help from "./pages/Help";

import InputWithdrawnAuthorization from "./pages/withdrawnAuthorizations/Input";
import PreviewWithdrawnAuthorization from "./pages/withdrawnAuthorizations/Preview";
import HistoryPreviewWithdrawnAuthorization from "./pages/withdrawnAuthorizations/HistoryPreview";
import SearchWithdrawnAuthorizations from "./pages/withdrawnAuthorizations/Search";

import InputWills from "./pages/wills/Input";
import PreviewWills from "./pages/wills/Preview";
import HistoryPreviewWills from "./pages/wills/HistoryPreview";
import SearchWills from "./pages/wills/Search";

import InputCertifications from "./pages/certifications/Input";
import PreviewCertification from "./pages/certifications/Preview";
import HistoryPreviewCertification from "./pages/certifications/HistoryPreview";
import SearchCertifications from "./pages/certifications/Search";

import PreviewMayorAuthorization from "./pages/mayor/Preview";
import HistoryPreviewMayorAuthorization from "./pages/mayor/HistoryPreview";
import SearchMayorAuthorizations from "./pages/mayor/Search";

import InputVehicleContract from "./pages/vehicleContracts/Input";
import PreviewVehicleContract from "./pages/vehicleContracts/Preview";
import WaitingVehicleContracts from "./pages/vehicleContracts/Waiting";
import SearchVehicleContracts from "./pages/vehicleContracts/Search";

import RequestObligation from "./pages/obligations/Request";
import SearchObligation from "./pages/obligations/Search";
import PreviewObligation from "./pages/obligations/Preview";

import Report from "./pages/Report";

import NotFound from "../common/components/pages/NotFound";
import Forbidden from "../common/components/pages/Forbidden";
import { RegisterType } from "../common/interfaces/enums/RegisterType";
import { ReportLogType } from "../interfaces/admin/LogReport";

export default function RoutesTree() {
  const publicRoutes = (
    <>
      <Route
        path={PublicRoutesConfig.Profile.Path}
        element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        }
      />
      <Route
        path={PublicRoutesConfig.Home.Path}
        element={
          <ProtectedRoute>
            <Home />
          </ProtectedRoute>
        }
      />

      <Route
        path={PublicRoutesConfig.Authorization.New.Path}
        element={
          <ProtectedRoute
            register={PublicRoutesConfig.Authorization}
            permissionType={PublicRoutesConfig.Authorization.New.Permission}
          >
            <InputAuthorization />
          </ProtectedRoute>
        }
      />
      <Route
        path={PublicRoutesConfig.Authorization.Edit.Path}
        element={
          <ProtectedRoute
            register={PublicRoutesConfig.Authorization}
            permissionType={PublicRoutesConfig.Authorization.Edit.Permission}
          >
            <InputAuthorization />
          </ProtectedRoute>
        }
      />
      <Route
        path={PublicRoutesConfig.Authorization.Preview.Path}
        element={
          <ProtectedRoute
            register={PublicRoutesConfig.Authorization}
            permissionType={PublicRoutesConfig.Authorization.Preview.Permission}
          >
            <PreviewAuthorization />
          </ProtectedRoute>
        }
      />
      <Route
        path={PublicRoutesConfig.Authorization.HistoryPreview.Path}
        element={
          <ProtectedRoute
            register={PublicRoutesConfig.Authorization}
            permissionType={PublicRoutesConfig.Authorization.HistoryPreview.Permission}
          >
            <HistoryPreviewAuthorization />
          </ProtectedRoute>
        }
      />
      <Route
        path={PublicRoutesConfig.Authorization.Search.Path}
        element={
          <ProtectedRoute
            register={PublicRoutesConfig.Authorization}
            permissionType={PublicRoutesConfig.Authorization.Search.Permission}
          >
            <SearchAuthorizations />
          </ProtectedRoute>
        }
      />

      <Route
        path={PublicRoutesConfig.WithdrawnAuthorization.New.Path}
        element={
          <ProtectedRoute
            register={PublicRoutesConfig.WithdrawnAuthorization}
            permissionType={PublicRoutesConfig.WithdrawnAuthorization.New.Permission}
          >
            <InputWithdrawnAuthorization />
          </ProtectedRoute>
        }
      />
      <Route
        path={PublicRoutesConfig.WithdrawnAuthorization.Edit.Path}
        element={
          <ProtectedRoute
            register={PublicRoutesConfig.WithdrawnAuthorization}
            permissionType={PublicRoutesConfig.WithdrawnAuthorization.Edit.Permission}
          >
            <InputWithdrawnAuthorization />
          </ProtectedRoute>
        }
      />
      <Route
        path={PublicRoutesConfig.WithdrawnAuthorization.Preview.Path}
        element={
          <ProtectedRoute
            register={PublicRoutesConfig.WithdrawnAuthorization}
            permissionType={PublicRoutesConfig.WithdrawnAuthorization.Preview.Permission}
          >
            <PreviewWithdrawnAuthorization />
          </ProtectedRoute>
        }
      />
      <Route
        path={PublicRoutesConfig.WithdrawnAuthorization.HistoryPreview.Path}
        element={
          <ProtectedRoute
            register={PublicRoutesConfig.WithdrawnAuthorization}
            permissionType={PublicRoutesConfig.WithdrawnAuthorization.HistoryPreview.Permission}
          >
            <HistoryPreviewWithdrawnAuthorization />
          </ProtectedRoute>
        }
      />
      <Route
        path={PublicRoutesConfig.WithdrawnAuthorization.Search.Path}
        element={
          <ProtectedRoute
            register={PublicRoutesConfig.WithdrawnAuthorization}
            permissionType={PublicRoutesConfig.WithdrawnAuthorization.Search.Permission}
          >
            <SearchWithdrawnAuthorizations />
          </ProtectedRoute>
        }
      />

      <Route
        path={PublicRoutesConfig.Will.New.Path}
        element={
          <ProtectedRoute register={PublicRoutesConfig.Will} permissionType={PublicRoutesConfig.Will.New.Permission}>
            <InputWills />
          </ProtectedRoute>
        }
      />
      <Route
        path={PublicRoutesConfig.Will.Edit.Path}
        element={
          <ProtectedRoute register={PublicRoutesConfig.Will} permissionType={PublicRoutesConfig.Will.Edit.Permission}>
            <InputWills />
          </ProtectedRoute>
        }
      />
      <Route
        path={PublicRoutesConfig.Will.Preview.Path}
        element={
          <ProtectedRoute
            register={PublicRoutesConfig.Will}
            permissionType={PublicRoutesConfig.Will.Preview.Permission}
          >
            <PreviewWills />
          </ProtectedRoute>
        }
      />
      <Route
        path={PublicRoutesConfig.Will.HistoryPreview.Path}
        element={
          <ProtectedRoute
            register={PublicRoutesConfig.Will}
            permissionType={PublicRoutesConfig.Will.HistoryPreview.Permission}
          >
            <HistoryPreviewWills />
          </ProtectedRoute>
        }
      />
      <Route
        path={PublicRoutesConfig.Will.Search.Path}
        element={
          <ProtectedRoute register={PublicRoutesConfig.Will} permissionType={PublicRoutesConfig.Will.Search.Permission}>
            <SearchWills />
          </ProtectedRoute>
        }
      />

      <Route
        path={PublicRoutesConfig.TZCertifications.New.Path}
        element={
          <ProtectedRoute
            register={PublicRoutesConfig.TZCertifications}
            permissionType={PublicRoutesConfig.TZCertifications.New.Permission}
          >
            <InputCertifications registerType={RegisterType.TZCertifications} />
          </ProtectedRoute>
        }
      />
      <Route
        path={PublicRoutesConfig.TZCertifications.Edit.Path}
        element={
          <ProtectedRoute
            register={PublicRoutesConfig.TZCertifications}
            permissionType={PublicRoutesConfig.TZCertifications.Edit.Permission}
          >
            <InputCertifications registerType={RegisterType.TZCertifications} />
          </ProtectedRoute>
        }
      />
      <Route
        path={PublicRoutesConfig.TZCertifications.Preview.Path}
        element={
          <ProtectedRoute
            register={PublicRoutesConfig.TZCertifications}
            permissionType={PublicRoutesConfig.TZCertifications.Preview.Permission}
          >
            <PreviewCertification registerType={RegisterType.TZCertifications} />
          </ProtectedRoute>
        }
      />
      <Route
        path={PublicRoutesConfig.TZCertifications.HistoryPreview.Path}
        element={
          <ProtectedRoute
            register={PublicRoutesConfig.TZCertifications}
            permissionType={PublicRoutesConfig.TZCertifications.HistoryPreview.Permission}
          >
            <HistoryPreviewCertification registerType={RegisterType.TZCertifications} />
          </ProtectedRoute>
        }
      />
      <Route
        path={PublicRoutesConfig.TZCertifications.Search.Path}
        element={
          <ProtectedRoute
            register={PublicRoutesConfig.TZCertifications}
            permissionType={PublicRoutesConfig.TZCertifications.Search.Permission}
          >
            <SearchCertifications key={RegisterType.TZCertifications} registerType={RegisterType.TZCertifications} />
          </ProtectedRoute>
        }
      />

      <Route
        path={PublicRoutesConfig.ZOZCertifications.New.Path}
        element={
          <ProtectedRoute
            register={PublicRoutesConfig.ZOZCertifications}
            permissionType={PublicRoutesConfig.ZOZCertifications.New.Permission}
          >
            <InputCertifications registerType={RegisterType.ZOZCertifications} />
          </ProtectedRoute>
        }
      />
      <Route
        path={PublicRoutesConfig.ZOZCertifications.Edit.Path}
        element={
          <ProtectedRoute
            register={PublicRoutesConfig.ZOZCertifications}
            permissionType={PublicRoutesConfig.ZOZCertifications.Edit.Permission}
          >
            <InputCertifications registerType={RegisterType.ZOZCertifications} />
          </ProtectedRoute>
        }
      />
      <Route
        path={PublicRoutesConfig.ZOZCertifications.Preview.Path}
        element={
          <ProtectedRoute
            register={PublicRoutesConfig.ZOZCertifications}
            permissionType={PublicRoutesConfig.ZOZCertifications.Preview.Permission}
          >
            <PreviewCertification registerType={RegisterType.ZOZCertifications} />
          </ProtectedRoute>
        }
      />
      <Route
        path={PublicRoutesConfig.ZOZCertifications.HistoryPreview.Path}
        element={
          <ProtectedRoute
            register={PublicRoutesConfig.ZOZCertifications}
            permissionType={PublicRoutesConfig.ZOZCertifications.HistoryPreview.Permission}
          >
            <HistoryPreviewCertification registerType={RegisterType.ZOZCertifications} />
          </ProtectedRoute>
        }
      />
      <Route
        path={PublicRoutesConfig.ZOZCertifications.Search.Path}
        element={
          <ProtectedRoute
            register={PublicRoutesConfig.ZOZCertifications}
            permissionType={PublicRoutesConfig.ZOZCertifications.Search.Permission}
          >
            <SearchCertifications key={RegisterType.ZOZCertifications} registerType={RegisterType.ZOZCertifications} />
          </ProtectedRoute>
        }
      />

      <Route
        path={PublicRoutesConfig.Vehicle.New.Path}
        element={
          <ProtectedRoute
            register={PublicRoutesConfig.Vehicle}
            permissionType={PublicRoutesConfig.Vehicle.New.Permission}
          >
            <InputVehicleContract />
          </ProtectedRoute>
        }
      />
      <Route
        path={PublicRoutesConfig.Vehicle.Edit.Path}
        element={
          <ProtectedRoute
            register={PublicRoutesConfig.Vehicle}
            permissionType={PublicRoutesConfig.Vehicle.Edit.Permission}
          >
            <InputVehicleContract />
          </ProtectedRoute>
        }
      />
      <Route
        path={PublicRoutesConfig.Vehicle.Preview.Path}
        element={
          <ProtectedRoute
            register={PublicRoutesConfig.Vehicle}
            permissionType={PublicRoutesConfig.Vehicle.Preview.Permission}
          >
            <PreviewVehicleContract />
          </ProtectedRoute>
        }
      />
      <Route
        path={PublicRoutesConfig.Vehicle.Waiting.Path}
        element={
          <ProtectedRoute
            register={PublicRoutesConfig.Vehicle}
            permissionType={PublicRoutesConfig.Vehicle.Waiting.Permission}
          >
            <WaitingVehicleContracts />
          </ProtectedRoute>
        }
      />
      <Route
        path={PublicRoutesConfig.Vehicle.Search.Path}
        element={
          <ProtectedRoute
            register={PublicRoutesConfig.Vehicle}
            permissionType={PublicRoutesConfig.Vehicle.Search.Permission}
          >
            <SearchVehicleContracts />
          </ProtectedRoute>
        }
      />

      <Route
        path={PublicRoutesConfig.NapObligations.Request.Path}
        element={
          <ProtectedRoute userTypes={PublicRoutesConfig.NapObligations.Request.UserTypes}>
            <RequestObligation />
          </ProtectedRoute>
        }
      />

      <Route
        path={PublicRoutesConfig.NapObligations.Search.Path}
        element={
          <ProtectedRoute userTypes={PublicRoutesConfig.NapObligations.Search.UserTypes}>
            <SearchObligation />
          </ProtectedRoute>
        }
      />

      <Route
        path={PublicRoutesConfig.NapObligations.Preview.Path}
        element={
          <ProtectedRoute userTypes={PublicRoutesConfig.NapObligations.Preview.UserTypes}>
            <PreviewObligation />
          </ProtectedRoute>
        }
      />

      <Route
        path={PublicRoutesConfig.MayorAuthorization.Preview.Path}
        element={
          <ProtectedRoute
            register={PublicRoutesConfig.MayorAuthorization}
            permissionType={PublicRoutesConfig.MayorAuthorization.Preview.Permission}
          >
            <PreviewMayorAuthorization />
          </ProtectedRoute>
        }
      />
      <Route
        path={PublicRoutesConfig.MayorAuthorization.HistoryPreview.Path}
        element={
          <ProtectedRoute
            register={PublicRoutesConfig.MayorAuthorization}
            permissionType={PublicRoutesConfig.MayorAuthorization.HistoryPreview.Permission}
          >
            <HistoryPreviewMayorAuthorization />
          </ProtectedRoute>
        }
      />
      <Route
        path={PublicRoutesConfig.MayorAuthorization.Search.Path}
        element={
          <ProtectedRoute
            register={PublicRoutesConfig.MayorAuthorization}
            permissionType={PublicRoutesConfig.MayorAuthorization.Search.Permission}
          >
            <SearchMayorAuthorizations />
          </ProtectedRoute>
        }
      />

      <Route
        path={PublicRoutesConfig.Report.Root.Path}
        element={
          <ProtectedRoute userTypes={PublicRoutesConfig.Report.Root.UserTypes}>
            <Report />
          </ProtectedRoute>
        }
      />
    </>
  );

  const adminRoutes = (
    <>
      <Route
        path={AdminRoutesConfig.Home.Path}
        element={
          <ProtectedRoute>
            <AdminHome />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.Notary.New.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.Notary.Root.UserTypes}>
            <InputNotary />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.Notary.Edit.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.Notary.Root.UserTypes}>
            <InputNotary />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.Notary.Preview.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.Notary.Root.UserTypes}>
            <PreviewNotary />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.Notary.Search.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.Notary.Root.UserTypes}>
            <SearchNotaries />
          </ProtectedRoute>
        }
      />

      <Route
        path={AdminRoutesConfig.NotaryDeputy.New.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.NotaryDeputy.Root.UserTypes}>
            <InputNotaryDeputy />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.NotaryDeputy.Edit.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.NotaryDeputy.Root.UserTypes}>
            <InputNotaryDeputy />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.NotaryDeputy.Preview.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.NotaryDeputy.Root.UserTypes}>
            <PreviewNotaryDeputy />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.NotaryDeputy.Search.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.NotaryDeputy.Root.UserTypes}>
            <SearchNotaryDeputies />
          </ProtectedRoute>
        }
      />

      <Route
        path={AdminRoutesConfig.ExternalUser.New.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.ExternalUser.Root.UserTypes}>
            <InputExternalUser />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.ExternalUser.Edit.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.ExternalUser.Root.UserTypes}>
            <InputExternalUser />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.ExternalUser.Preview.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.ExternalUser.Root.UserTypes}>
            <PreviewExternalUser />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.ExternalUser.Search.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.ExternalUser.Root.UserTypes}>
            <SearchExternalUsers />
          </ProtectedRoute>
        }
      />

      <Route
        path={AdminRoutesConfig.RegistryAgencyUser.New.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.RegistryAgencyUser.Root.UserTypes}>
            <InputRegistryAgencyUser />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.RegistryAgencyUser.Edit.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.RegistryAgencyUser.Root.UserTypes}>
            <InputRegistryAgencyUser />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.RegistryAgencyUser.Preview.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.RegistryAgencyUser.Root.UserTypes}>
            <PreviewRegistryAgencyUser />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.RegistryAgencyUser.Search.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.RegistryAgencyUser.Root.UserTypes}>
            <SearchRegistryAgencyUsers />
          </ProtectedRoute>
        }
      />

      <Route
        path={AdminRoutesConfig.BankUser.New.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.BankUser.Root.UserTypes}>
            <InputBankUser />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.BankUser.Edit.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.BankUser.Root.UserTypes}>
            <InputBankUser />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.BankUser.Preview.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.BankUser.Root.UserTypes}>
            <PreviewBankUser />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.BankUser.Search.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.BankUser.Root.UserTypes}>
            <SearchBankUsers />
          </ProtectedRoute>
        }
      />

      <Route
        path={AdminRoutesConfig.InvestmentBrokerUser.New.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.InvestmentBrokerUser.Root.UserTypes}>
            <InputInvestmentBrokerUser />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.InvestmentBrokerUser.Edit.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.InvestmentBrokerUser.Root.UserTypes}>
            <InputInvestmentBrokerUser />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.InvestmentBrokerUser.Preview.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.InvestmentBrokerUser.Root.UserTypes}>
            <PreviewInvestmentBrokerUser />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.InvestmentBrokerUser.Search.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.InvestmentBrokerUser.Root.UserTypes}>
            <SearchInvestmentBrokerUsers />
          </ProtectedRoute>
        }
      />

      <Route
        path={AdminRoutesConfig.InsurerUser.New.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.InsurerUser.Root.UserTypes}>
            <InputInsurerUser />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.InsurerUser.Edit.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.InsurerUser.Root.UserTypes}>
            <InputInsurerUser />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.InsurerUser.Preview.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.InsurerUser.Root.UserTypes}>
            <PreviewInsurerUser />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.InsurerUser.Search.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.InsurerUser.Root.UserTypes}>
            <SearchInsurerUsers />
          </ProtectedRoute>
        }
      />

      <Route
        path={AdminRoutesConfig.Mayor.New.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.Mayor.Root.UserTypes}>
            <InputMayor />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.Mayor.Edit.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.Mayor.Root.UserTypes}>
            <InputMayor />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.Mayor.Preview.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.Mayor.Root.UserTypes}>
            <PreviewMayor />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.Mayor.Search.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.Mayor.Root.UserTypes}>
            <SearchMayors />
          </ProtectedRoute>
        }
      />

      <Route
        path={AdminRoutesConfig.Bank.New.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.Bank.Root.UserTypes}>
            <InputBank />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.Bank.Edit.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.Bank.Root.UserTypes}>
            <InputBank />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.Bank.Search.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.Bank.Root.UserTypes}>
            <SearchBanks />
          </ProtectedRoute>
        }
      />

      <Route
        path={AdminRoutesConfig.BankBranch.New.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.BankBranch.Root.UserTypes}>
            <InputBankBranch />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.BankBranch.Edit.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.BankBranch.Root.UserTypes}>
            <InputBankBranch />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.BankBranch.Search.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.BankBranch.Root.UserTypes}>
            <SearchBankBranches />
          </ProtectedRoute>
        }
      />

      <Route
        path={AdminRoutesConfig.InvestmentBroker.New.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.InvestmentBroker.Root.UserTypes}>
            <InputInvestmentBroker />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.InvestmentBroker.Edit.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.InvestmentBroker.Root.UserTypes}>
            <InputInvestmentBroker />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.InvestmentBroker.Search.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.InvestmentBroker.Root.UserTypes}>
            <SearchInvestmentBrokers />
          </ProtectedRoute>
        }
      />

      <Route
        path={AdminRoutesConfig.InvestmentBrokerBranch.New.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.InvestmentBrokerBranch.Root.UserTypes}>
            <InputInvestmentBrokerBranch />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.InvestmentBrokerBranch.Edit.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.InvestmentBrokerBranch.Root.UserTypes}>
            <InputInvestmentBrokerBranch />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.InvestmentBrokerBranch.Search.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.InvestmentBrokerBranch.Root.UserTypes}>
            <SearchInvestmentBrokerBranches />
          </ProtectedRoute>
        }
      />

      <Route
        path={AdminRoutesConfig.Insurer.New.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.Insurer.Root.UserTypes}>
            <InputInsurer />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.Insurer.Edit.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.Insurer.Root.UserTypes}>
            <InputInsurer />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.Insurer.Search.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.Insurer.Root.UserTypes}>
            <SearchInsurers />
          </ProtectedRoute>
        }
      />

      <Route
        path={AdminRoutesConfig.InsurerBranch.New.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.InsurerBranch.Root.UserTypes}>
            <InputInsurerBranch />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.InsurerBranch.Edit.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.InsurerBranch.Root.UserTypes}>
            <InputInsurerBranch />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.InsurerBranch.Search.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.InsurerBranch.Root.UserTypes}>
            <SearchInsurerBranches />
          </ProtectedRoute>
        }
      />

      <Route
        path={AdminRoutesConfig.BankAuthorizationLog.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.BankAuthorizationLog.UserTypes}>
            <SearchReports
              key={AdminRoutesConfig.BankAuthorizationLog.Label}
              reportLogType={ReportLogType.BankAuthorizationReportLog}
              registerName={AdminRoutesConfig.BankAuthorizationLog.Label}
            />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.BankWithdrawnAuthorizationLog.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.BankWithdrawnAuthorizationLog.UserTypes}>
            <SearchReports
              key={AdminRoutesConfig.BankWithdrawnAuthorizationLog.Label}
              reportLogType={ReportLogType.BankWithdrawnAuthorizationReportLog}
              registerName={AdminRoutesConfig.BankWithdrawnAuthorizationLog.Label}
            />
          </ProtectedRoute>
        }
      />

      <Route
        path={AdminRoutesConfig.InvestmentBrokerAuthorizationLog.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.InvestmentBrokerAuthorizationLog.UserTypes}>
            <SearchReports
              key={AdminRoutesConfig.InvestmentBrokerAuthorizationLog.Label}
              reportLogType={ReportLogType.InvestmentBrokerAuthorizationLog}
              registerName={AdminRoutesConfig.InvestmentBrokerAuthorizationLog.Label}
            />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.InvestmentBrokerWithdrawnAuthorizationLog.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.InvestmentBrokerWithdrawnAuthorizationLog.UserTypes}>
            <SearchReports
              key={AdminRoutesConfig.InvestmentBrokerWithdrawnAuthorizationLog.Label}
              reportLogType={ReportLogType.InvestmentBrokerWithdrawnAuthorizationLog}
              registerName={AdminRoutesConfig.InvestmentBrokerWithdrawnAuthorizationLog.Label}
            />
          </ProtectedRoute>
        }
      />

      <Route
        path={AdminRoutesConfig.InsurerAuthorizationLog.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.InsurerAuthorizationLog.UserTypes}>
            <SearchReports
              key={AdminRoutesConfig.InsurerAuthorizationLog.Label}
              reportLogType={ReportLogType.InsurerAuthorizationLog}
              registerName={AdminRoutesConfig.InsurerAuthorizationLog.Label}
            />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.InsurerWithdrawnAuthorizationLog.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.InsurerWithdrawnAuthorizationLog.UserTypes}>
            <SearchReports
              key={AdminRoutesConfig.InsurerWithdrawnAuthorizationLog.Label}
              reportLogType={ReportLogType.InsurerWithdrawnAuthorizationLog}
              registerName={AdminRoutesConfig.InsurerWithdrawnAuthorizationLog.Label}
            />
          </ProtectedRoute>
        }
      />
      <Route
        path={AdminRoutesConfig.NapObligationLog.Path}
        element={
          <ProtectedRoute userTypes={AdminRoutesConfig.NapObligationLog.UserTypes}>
            <SearchReports
              key={AdminRoutesConfig.NapObligationLog.Label}
              reportLogType={ReportLogType.NapObligationLog}
              registerName={AdminRoutesConfig.NapObligationLog.Label}
            />
          </ProtectedRoute>
        }
      />
    </>
  );

  return (
    <Routes>
      {/* common routes */}
      <Route path={CommonRoutesConfig.Login.Path} element={<Login />} />
      <Route path={CommonRoutesConfig.LoginRoute.Path} element={<Login />} />
      <Route path={CommonRoutesConfig.LoginWithPassword.Path} element={<LoginWithPassword />} />
      <Route path={CommonRoutesConfig.AdminLogin.Path} element={<AdminLogin />} />
      <Route
        path={CommonRoutesConfig.Logout.Path}
        element={
          <ProtectedRoute>
            <Logout />
          </ProtectedRoute>
        }
      />
      <Route path={CommonRoutesConfig.Help.Path} element={<Help />} />
      <Route path={CommonRoutesConfig.Forbidden.Path} element={<Forbidden />} />
      <Route path={CommonRoutesConfig.NotFound.Path} element={<NotFound />} />
      <Route path={CommonRoutesConfig.SSL.Path} element={<Navigate to={CommonRoutesConfig.Login.Path} />} />

      {publicRoutes}
      {adminRoutes}
    </Routes>
  );
}
